import classNames from 'classnames';

// Partials
import CoreLoader from '../../../core/views/partials/loader';

const StyledLoader = ({ full, className, ...props }) => {
	return <CoreLoader {...props} className={classNames(className, { full })} />;
};

export default StyledLoader;
